<template>
  <div
    v-if="Object.keys(personalData).length != 0 && loginRadio != -1 && bgImg != '' && bgImg && logoImg && logoImg != ''"
    class="personal-container"
    :style="{ 'background-image': 'url(' + bgImg + ')' }"
  >
    <img :src="logoImg" :style="logoPosition" class="personal-logo" height="34px" />
    <div class="loginBox" :style="loginPosition">
      <div class="title" v-if="logoRadio != 3">
        欢迎登录
      </div>
      <div class="title" v-else>
        <img :src="logoImg" height="34px" alt="" />
      </div>
      <!--  -->
      <div class="inputBox">
        <div class="item">
          <i class="iconfont icon-dengluzuhu" />
          <input
            type="text"
            v-model="formLogin.tenantCode"
            placeholder="请输入租户编号"
            autocomplete="off"
            v-on:keyup.enter="submit"
          />
        </div>

        <div class="item">
          <i class="iconfont icon-dengluzhanghao" />
          <input
            type="text"
            v-model="formLogin.userCode"
            placeholder="请输入用户账号"
            autocomplete="off"
            v-on:keyup.enter="submit"
          />
        </div>

        <div class="item">
          <i class="iconfont icon-denglumima" />
          <input
            type="password"
            v-model="formLogin.userPassword"
            placeholder="请输入密码"
            autocomplete="off"
            v-on:keyup.enter="submit"
          />
        </div>

        <el-row type="flex" justify="space-between">
          <el-col :span="8">
            <el-checkbox v-model="formLogin.saveName">记住账号</el-checkbox>
          </el-col>
          <el-col :span="8">
            <el-checkbox v-model="formLogin.savePwd" style="float: right">记住密码</el-checkbox>
          </el-col>
        </el-row>
        <el-button
          @click="submit"
          size="large"
          type="primary"
          class="button-login"
          :loading="loading"
          :disabled="btnStatus && !loading"
          style="width: 100%;margin: 30px 0 40px 0"
          >登录</el-button
        >
      </div>
    </div>
    <div class="personal--bottom">
      {{ downTitle.copyRight }}
      <a href="https://beian.miit.gov.cn/" target="_blank">{{ downTitle.website }}</a>
      <a
        href="http://www.beian.gov.cn/portal/recordQuery?token=a5407685-9f62-406f-8076-3d027839adc5"
        target="_blank"
        style="margin-left:10px"
      >
        <img src="../../assets/image/beian.png" style="vertical-align: middle" />
        {{ downTitle.onRecord }}
      </a>
    </div>
  </div>
  <div v-else class="login-container">
    <div class="login-logo" style="margin: 6px 0 0 6px">
      <img src="../../assets/image/logo1.png" height="34px" />
    </div>
    <div class="login-wrapper">
      <div class="login-wrapper--text">
        <img src="../../assets/image/login-text1.png" width="400px" />
        <div class="item" style="margin-top: 21px">核心功能：</div>
        <ul>
          <li>智能调度</li>
          <li>北斗定位</li>
          <li>主动安全</li>
          <li>语音对讲</li>
        </ul>
        <ul style="margin-bottom: 14px">
          <li>视频监控</li>
          <li>油耗监测</li>
          <li>胎压监测</li>
          <li>温度监测</li>
        </ul>
        <div class="item">应用场景：</div>
        <ul>
          <li>公路货运</li>
          <li>城市配送</li>
          <li>公务用车</li>
          <li>生产用车</li>
        </ul>
        <ul>
          <li>执法车队</li>
          <li>两客一危</li>
          <li>应急抢修</li>
          <li>市政环卫</li>
        </ul>
      </div>
      <div class="login-wrapper--content">
        <section class="login-wrapper--welcome">
          <img src="../../assets/image/login-welcome.png" height="53px" />
          <div class="erweima androidImg">
            <img src="../../assets/image/anzhuoerweimapng.png" width="80px" />
            <div>安卓下载</div>
          </div>
          <div class="erweima iosImg">
            <img src="../../assets/image/ioserweima.png" width="80px" />
            <div>IOS下载</div>
          </div>
        </section>
        <div class="login-wrapper--input">
          <i class="iconfont icon-dengluzuhu" />
          <input
            type="text"
            v-model="formLogin.tenantCode"
            placeholder="请输入租户编号"
            autocomplete="off"
            v-on:keyup.enter="submit"
          />
        </div>
        <div class="login-wrapper--input">
          <i class="iconfont icon-dengluzhanghao" />
          <input
            type="text"
            v-model="formLogin.userCode"
            placeholder="请输入用户账号"
            autocomplete="off"
            v-on:keyup.enter="submit"
          />
        </div>
        <div class="login-wrapper--input">
          <i class="iconfont icon-denglumima" />
          <input
            type="password"
            v-model="formLogin.userPassword"
            placeholder="请输入密码"
            autocomplete="off"
            v-on:keyup.enter="submit"
          />
        </div>
        <el-row type="flex" justify="space-between">
          <el-col :span="8">
            <el-checkbox v-model="formLogin.saveName">记住账号</el-checkbox>
          </el-col>
          <el-col :span="8">
            <el-checkbox v-model="formLogin.savePwd" style="float: right">记住密码</el-checkbox>
          </el-col>
        </el-row>
        <el-button
          @click="submit"
          size="large"
          type="primary"
          class="button-login"
          :loading="loading"
          :disabled="btnStatus && !loading"
          >登录</el-button
        >
      </div>
    </div>
    <div class="login-wrapper--bottom">
      {{ downTitle.copyRight }}
      <a href="https://beian.miit.gov.cn/" target="_blank">{{ downTitle.website }}</a>
      <a
        href="http://www.beian.gov.cn/portal/recordQuery?token=a5407685-9f62-406f-8076-3d027839adc5"
        target="_blank"
        style="margin-left:10px"
      >
        <img src="../../assets/image/beian.png" style="vertical-align: middle" />
        {{ downTitle.onRecord }}
      </a>
    </div>
    <RenewNotify v-show="false"></RenewNotify>
  </div>
</template>
<script>
import { mapActions, mapMutations } from 'vuex'
import CryptoJS from 'crypto-js'

export default {
  components: {
    RenewNotify: () => import('./components/renew-notify'),
  },
  data() {
    return {
      switchBtn: false,
      loading: false,
      formLogin: {
        tenantCode: '',
        userCode: '',
        userPassword: '',
      },
      personalData: {},
      downTitle: {
        copyRight: 'Copyright © 2019-2020 Wyiot ',
        website: '浙ICP备14009320号-9',
        onRecord: '浙公网安备33010302003699',
      },
      bgImg: '',
      logoImg: '',
      logoRadio: '1',
      loginRadio: '-1',
    }
  },
  computed: {
    btnStatus() {
      let { userCode, tenantCode, userPassword } = this.formLogin
      return !(userCode && tenantCode && userPassword)
    },

    logoPosition() {
      if (this.logoRadio == 1) {
        return 'left: 0'
      }
      if (this.logoRadio == 2) {
        return 'right: 0'
      }
      if (this.logoRadio == 3) {
        return 'display: none'
      }
    },
    loginPosition() {
      if (this.loginRadio == 1) {
        return 'left: 180px'
      }
      if (this.loginRadio == 3) {
        return 'right: 180px'
      }
      if (this.loginRadio == 2) {
        return 'left: 50%; transform: translate(-50%, -50%)'
      }
    },
  },
  mounted() {
    this.personalData = this.$ls.get('personalSetting') || {}

    if (
      Object.keys(this.personalData).length != 0 &&
      this.personalData.loginRadio != -1 &&
      this.personalData.bgImg != '' &&
      this.personalData.logoImg != ''
    ) {
      try {
        let obj = JSON.parse(this.personalData.downTitle)
        this.downTitle.copyRight = obj.copyRight
        this.downTitle.website = obj.website
        this.downTitle.onRecord = obj.onRecord
      } catch (error) {
        this.downTitle = {
          copyRight: 'Copyright © 2019-2020 Wyiot ',
          website: '浙ICP备14009320号-9',
          onRecord: '浙公网安备33010302003699',
        }
      }
      this.bgImg = this.personalData.backgroundImage
      this.logoImg = this.personalData.loginLogo
      this.loginRadio = this.personalData.loginLocation
      this.logoRadio = this.personalData.logoLocation
    }

    this.formLogin.userCode = this.$ls.get('userCode') || ''
    let tenantName = window.localStorage.getItem('megrez-tenantCode')
    let tenantCode = ''
    try {
      let _obj = JSON.parse(tenantName)
      tenantCode = _obj.value
    } catch (error) {
      tenantCode = ''
    }
    this.formLogin.tenantCode = tenantCode
    this.formLogin.userPassword = this.$ls.get('userPassword') || ''
    if (this.$ls.get('userCode')) {
      this.$set(this.formLogin, 'saveName', true)
    }
    if (this.$ls.get('userPassword')) {
      this.$set(this.formLogin, 'savePwd', true)
    }
  },
  methods: {
    ...mapActions(['Login', 'Logout']),
    ...mapMutations(['SET_TENANTINFO', 'SET_CURRENTAPP']),
    async submit() {
      let { formLogin } = this

      if (formLogin.saveName) {
        this.$ls.set('tenantCode', formLogin.tenantCode)
        this.$ls.set('userCode', formLogin.userCode)
      } else {
        this.$ls.remove('tenantCode')
        this.$ls.remove('userCode')
      }
      if (formLogin.savePwd) {
        this.$ls.set('userPassword', formLogin.userPassword)
      } else {
        this.$ls.remove('userPassword')
      }
      this.loading = true
      const data = await this.$api.doLogin({
        ...formLogin,
        userPassword: CryptoJS.SHA1(this.formLogin.userPassword).toString(),
      })
      this.loading = false
      if (data.success) {
        this.$ls.set('userPhone', data.datas.userPhone)
        this.loginSuccess(data)
        const personal = await this.$api.personalSetting(data.datas.tenantId)
        if (personal.success) {
          this.$ls.set('personalSetting', personal.datas.content)
          window.localStorage.setItem('icon', personal.datas.content.icon)
        }
      }
    },
    loginSuccess(res) {
      if (!res.success) {
        return
      }
      this.$ls.set('token', 'islogin')
      this.$ls.set('userName', res.datas.userName)
      this.$ls.set('tenantName', res.datas.tenantName)
      this.$ls.set('userId', res.datas.userId)
      this.$ls.set('tenantId', res.datas.tenantId)
      this.$ls.set('orgId', res.datas.orgId)
      this.$router.push('/')
      this.getRenewList()
    },
    // 登录后获取该用户是否有过期设备
    getRenewList() {
      this.$api.renewRemind().then(({ datas }) => {
        if (datas.content) {
          setTimeout(() => {
            this.showNotify()
          }, 1500)
        }
      })
    },
    // 弹框提示续费
    showNotify() {
      const notify = this.$notify({
        customClass: 'renew-notify',
        title: '续费提醒',
        offset: 50,
        dangerouslyUseHTMLString: true,
        message: this.$createElement('RenewNotify', {
          ref: 'RenewNotify',
          on: {
            close: () => {
              notify.close()
            },
            goRouter: () => {
              notify.close()
              this.$router.push({
                path: '/cost/manage',
                query: {
                  activeName: '3',
                },
              })
            },
          },
        }),
        type: 'warning',
        duration: 0,
      })
    },
  },
}
</script>

<style lang="scss">
.personal-container {
  position: fixed;
  height: 100%;
  width: 100%;
  background-size: cover;
  .personal-logo {
    position: absolute;
    margin: 0 3.2%;
    top: 3.6%;
  }
  .loginBox {
    width: 24%;
    // height: 46%;
    min-width: 280px;
    background-color: rgba(255, 255, 255, 0.9);
    border-radius: 2px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    .title {
      line-height: 90px;
      text-align: center;
      font-size: 22px;
      margin-bottom: 20px;
      img {
        vertical-align: sub;
        max-width: 320px;
      }
    }
    .title::selection {
      color: #2cac85;
    }
    .inputBox {
      width: 90%;
      margin: 0 auto;
      position: relative;
      .item {
        margin-bottom: 28px;
        position: relative;
        i {
          position: absolute;
          left: 20px;
          font-size: 23px;
          top: 50%;
          transform: translateY(-50%);
          color: #e1e1e1;
        }
      }
      input {
        box-sizing: border-box;
        width: 100%;
        height: 44px;
        line-height: 44px;
        padding: 0px 0px 0px 60px;
        border-width: 0px 0px 1px;
        color: #6d7278;
        box-sizing: border-box;
        border: 1px solid #e1e1e1;
        border-width: 0px 0px 1px;
        &:focus {
          border-width: 0px 0px 1px;
          border-color: #409eff;
        }
        // &:focus-visible{
        //     border-width: 0px 0px 1px;
        //     border-color:#409EFF
        // }
        // &::-webkit-input-placeholder {
        //   color: #ced1d5;
        // }
        &:focus-visible {
          outline: none;
        }
      }
    }
  }
  .personal--bottom {
    position: absolute;
    text-align: center;
    bottom: 20px;
    width: 100%;
    font-size: 14px;
    color: rgba(102, 102, 102, 0.5);
  }
}
.login {
  &-container {
    position: fixed;
    height: 100%;
    width: 100%;
    background: url('~@/assets/image/login-bg1.png') 50% 50% no-repeat;
    background-size: cover;
    .login-wrapper--bottom {
      position: absolute;
      text-align: center;
      bottom: 20px;
      width: 100%;
      font-size: 14px;
      color: rgba(102, 102, 102, 0.5);
    }
  }

  &-logo {
    position: absolute;
    left: 3.2%;
    top: 3.6%;
  }
  // &-advertisement {
  //   position: absolute;
  //   top: 50%;
  //   transform: translateY(-50%);
  //   right: 9%;
  // }
  &-wrapper {
    width: 1257px;
    height: 636px;
    box-sizing: border-box;
    position: absolute;
    border-radius: 18px;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -295px);
    background: url('~@/assets/image/login-bg_in.png') 50% 50% no-repeat;
    background-size: cover;
    &--text {
      position: absolute;
      top: 90px;
      left: 52px;
      font-size: 14px;
      color: #ffffff;
      .item {
        height: 22px;
        line-height: 22px;
        margin-bottom: 14px;
      }
      ul {
        padding: 0;
        margin: 0 0 4px 0;
      }
      li {
        display: inline-block;
        margin-right: 28px;
        &::after {
          content: '';
          display: inline-block;
          width: 5px;
          height: 5px;
          vertical-align: middle;
          border-radius: 50%;
          background-color: #fff;
          margin: 0 0 3px 28px;
        }
        &:nth-child(4n) {
          &::after {
            content: none;
          }
        }
      }
    }
    &--content {
      position: absolute;
      width: 34%;
      right: 65px;
      height: 100%;
      box-sizing: border-box;
    }
    &--welcome {
      margin-top: 110px;
      margin-bottom: 50px;
      .erweima {
        position: absolute;
        text-align: center;
        font-size: 7.56px;
        div {
          height: 11px;
          line-height: 11px;
          margin-top: 3px;
          color: #131415;
          font-weight: 600;
        }
        &.androidImg {
          top: 92px;
          right: 95px;
        }
        &.iosImg {
          top: 92px;
          right: 0;
        }
      }
    }
    &--input {
      margin-bottom: 28px;
      position: relative;
      i {
        position: absolute;
        left: 20px;
        font-size: 23px;
        top: 50%;
        transform: translateY(-50%);
        color: #e1e1e1;
      }
    }
    input {
      width: 100%;
      height: 44px;
      line-height: 44px;
      padding: 0px 0px 0px 60px;
      border-width: 0px 0px 1px;
      color: #6d7278;
      box-sizing: border-box;
      border: 1px solid #e1e1e1;
      // &:focus{
      //     border-width: 0px 0px 1px;
      //     border-color:#409EFF
      // }
      &::-webkit-input-placeholder {
        color: #ced1d5;
      }
    }

    input[type='text']:focus,
    input[type='password']:focus {
      // border: 2px solid #f00;
      border: 1px solid #e1e1e1;
      box-shadow: none;
      outline: none;
    }

    .el-checkbox {
      color: #6d7278;
    }
    .el-form-item {
      .el-form-item__error {
        padding-top: 12px;
      }
    }
    .button-login {
      width: 100%;
      margin-top: 28px;
      height: 47px;
      font-size: 16px;
      background: #00a37d;
    }
    .el-button--primary.is-disabled {
      background-image: none;
    }
  }
}
</style>
